import { Component, input, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-pg-share',
    templateUrl: './pg-share.component.html',
    styleUrls: ['./pg-share.component.scss'],
    standalone: false
})
export class PgShareComponent implements OnInit {
    constructor() { }

    @Input() shareURL:string;
    @Input() shareTitle:string;
    @Input() shareText:string;

    @Input() buttonClass:string;
    @Input() isSmall:boolean;

    ngOnInit(): void {
    }
    
    /*
    availableSocials:Array<{ id: string, label: string }> = [
        { id: 'whatsapp', 'label': 'Whatsapp' },
        { id: 'instagram', 'label': 'Instagram' },
        { id: 'facebook', 'label': 'Facebook' },
        { id: 'telegram', 'label': 'Telegram' },
    ]

    doShare(social:string) {
        switch(social) {
            case 'whatsapp':
                window.open('https://wa.me/?text=' + encodeURIComponent(window.location.href))
                break;
            
        }
    }
    */

    doWebShare() {
        navigator.share({
            title: this.shareTitle || '',
            text: this.shareText || '',
            url: this.shareURL || window.location.href,
        }).then(() => {
        }, () => {
        })
    }
}
